import React from "react";
import classes from "./header.module.css";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import PropTypes from "prop-types";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const Header = ({ toggleSidebar, Open }) => {
   return (
      <div className={classes.container}>
         <div className={classes.toggleIcon}>
            <IconButton
               color="inherit"
               aria-label="open drawer"
               onClick={toggleSidebar}
               edge="start"
            >
               {Open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>
         </div>
      </div>
   );
};

Header.propTypes = {
   toggleSidebar: PropTypes.func,
   Open: PropTypes.bool,
};

export default Header;
